define('OrderWizard.Module.Shipmethod.Extension', [
  'OrderWizard.Module.Shipmethod',

  'Backbone',
  'SC.Configuration',
  'jQuery',
  'Utils',
  'underscore'
], function (
  OrderWizardModuleShipmethod,

  Backbone,
  Configuration,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(OrderWizardModuleShipmethod.prototype, {
    getContext: _.wrap(OrderWizardModuleShipmethod.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var shipMethods = context.shippingMethods;
      var placeholderShippingItem = Configuration.get('customship.placeholderid');

      if (shipMethods.length) {
        var tbd = _.findWhere(shipMethods, { internalid: placeholderShippingItem });
        if(tbd)
        {

          tbd.rate_formatted = '';
        }
      }

      return context;
    })
  });
});
